import { Box, Text } from '@wix/design-system';
import React from 'react';
export const TaxIncludedLabel = ({ className, dataHook, children, inline, size, }) => {
    const marginTop = inline ? '0' : '6px';
    const fontSize = inline ? size : 'tiny';
    const align = inline ? 'left' : 'center';
    return (React.createElement(Box, { className: className, align: align, marginTop: marginTop },
        React.createElement(Text, { size: fontSize, dataHook: dataHook, secondary: true }, children)));
};
//# sourceMappingURL=TaxIncludedLabel.js.map